
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import App from './App.tsx'
import './index.css'

// Initialize Lovable tools if they exist
const initializeLovableTools = async () => {
  if (import.meta.env.DEV && window.LovableTools) {
    try {
      await window.LovableTools.initialize();
    } catch (error) {
      console.error("Failed to initialize Lovable tools:", error);
    }
  }
};

// Run initialization
initializeLovableTools();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <Analytics />
    <SpeedInsights />
  </React.StrictMode>
);
